import classNames from 'classnames';
import './InputDataPrompt.less';
import { Button } from 'components/buttons';
import { useCallback } from 'react';

export interface IInputDataPromptProps {
  message?: string;
  hasInputData?: boolean;
  patternName?: string;
  hasDesignPattern?: boolean;
  onEditInputData?: () => void;
  onEditDesignPattern?: () => void;
}

function getMessageClassName(isEmpty?: boolean) {
  return classNames('dp-input-data-prompt__message', {
    'dp-input-data-prompt__message--empty': isEmpty,
  });
}

export function InputDataPrompt({
  message,
  hasInputData,
  patternName,
  hasDesignPattern,
  onEditInputData,
  onEditDesignPattern,
}: IInputDataPromptProps) {
  const InputData = useCallback(({ canBeEdit }: { canBeEdit?: boolean }) => (
    <div className="dp-input-data-prompt__defined-data">
      <div className="dp-input-data-prompt__label">Given Inputs:</div>
      <div title={message} className={getMessageClassName()}>
        {message}
      </div>
      {canBeEdit && (
        <Button variant="outline" className="dp-input-data-prompt__button" onClick={onEditInputData}>
          edit
        </Button>
      )}
    </div>
  ), [message, onEditInputData]);

  if (hasDesignPattern) {
    return (
      <div className="dp-input-data-prompt">
        {hasInputData ? (
          <InputData />
        ) : (
          <div className="dp-input-data-prompt__message dp-input-data-prompt__message--empty">
            Design Pattern Doesn't Have Input Data
          </div>
        )}
        <div className="dp-input-data-prompt__from-design-pattern">
          <div className="dp-input-data-prompt__label">From:</div>
          <div title={patternName} className={getMessageClassName()}>
            {patternName}
          </div>
          <Button variant="outline" className="dp-input-data-prompt__button" onClick={onEditDesignPattern}>
            view
          </Button>
        </div>
      </div>
    );
  }

  if (!hasInputData) {
    return (
      <div className="dp-input-data-prompt">
        <div className={getMessageClassName(true)}>Input Data is information passed into the flow</div>
        <Button variant="outline" className="dp-input-data-prompt__button" onClick={onEditInputData}>
          Setup Input Data
        </Button>
      </div>
    );
  }

  return (
    <div className="dp-input-data-prompt">
      <InputData canBeEdit={true} />
    </div>
  );
}
